/* eslint-disable react/jsx-no-target-blank */
import { useCallback, useEffect, useMemo, useState } from "react";
import cryptoJS from "crypto-js";
import {
  CODE,
  FollowI,
  FOLLOW_FLG_ENUM,
  LOGGED_ENUM,
  SessionI,
} from "./z-types";
import {
  checkHaveSession,
  onRequestCheckFollow,
  onRequestFollow,
} from "./services";

import Spinner from "./components/spinner";

import "./App.scss";

const owlClass = "app";
const location = window.location;
const FOLLOW_ENTRY = ["oaid", "customize", "style"];

const isMobile = () =>
  navigator.userAgent.match(/Android/i) ||
  navigator.userAgent.match(/webOS/i) ||
  navigator.userAgent.match(/iPhone/i) ||
  navigator.userAgent.match(/iPad/i) ||
  navigator.userAgent.match(/iPod/i) ||
  navigator.userAgent.match(/BlackBerry/i) ||
  navigator.userAgent.match(/IEMobile/i) ||
  navigator.userAgent.match(/Opera Mini/i) ||
  navigator.userAgent.match(/Windows Phone/i);

const usingBrowser = () => {
  const test = function (regexp: any) {
    return regexp.test(window.navigator.userAgent);
  };
  switch (true) {
    case test(/edg/i):
      return "Microsoft Edge";
    case test(/trident/i):
      return "Microsoft Internet Explorer";
    case test(/firefox|fxios/i):
      return "Mozilla Firefox";
    case test(/opr\//i):
      return "Opera";
    case test(/ucbrowser/i):
      return "UC Browser";
    case test(/samsungbrowser/i):
      return "Samsung Browser";
    case test(/chrome|chromium|crios/i):
      return "Google Chrome";
    case test(/safari/i):
      return "Apple Safari";
    default:
      return "Other";
  }
};

const isValidURL = (str: string): boolean => {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
    "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
};

function generateACharacter() {
  const alphabet = "abcdefghijklmnopqrstuvwxyz";

  return alphabet[Math.floor(Math.random() * alphabet.length)];
}

const characters =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
function generateString(length: number) {
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}

function App() {
  const [isLogged, setIsLogged] = useState(false);
  const [isLoading, setIsLoading] = useState<any>(null);
  const [isRedirecting, setIsRedirecting] = useState<any>(null);
  const isZaloPay = useMemo(
    () => window.navigator.userAgent.toLocaleLowerCase().indexOf("zalopay") > 1,
    []
  );

  const isAutoClose = useMemo(
    () => new URLSearchParams(window.location.search).get("auto_close"),
    []
  );

  const isCustomize = useMemo(() => {
    const redirectTo = new URLSearchParams(window.location.search).get(
      "redirectTo"
    );

    if (redirectTo) {
      return false;
    } else {
      return (
        location.search
          .substring(1)
          .split("&")
          .map((item) => item.split("="))
          .filter((item) => FOLLOW_ENTRY[1].includes(item[0]))[0][1] === "true"
      );
    }
  }, []);

  const handleFollow = useCallback(
    (atk: string) => {
      const filterEntry = location.search
        .substring(1)
        .split("&")
        .map((item) => item.split("="))
        .filter((item) => FOLLOW_ENTRY.includes(item[0]));
      const convertToObject = Object.fromEntries(filterEntry);
      const entry = {
        t: atk,
        ...convertToObject,
        customize: false,
      };

      onRequestFollow(entry)
        .then((rs: any) => {
          const data = rs as FollowI;
          if (data.error === CODE.SUCCESS) {
            if (data.isLogged === LOGGED_ENUM.LOGGED) {
              setIsLogged(true);
            }
          } else if (!Object.values(data).length) {
            setIsLogged(true);
          }
          setIsLoading(false);

          const redirectTo = new URLSearchParams(window.location.search).get(
            "redirectTo"
          );

          if (redirectTo) {
            window.open(redirectTo, "_parent");
          }
          const notCallbackFunc = location.search
            .substring(1)
            .split("&")
            .find((item) => item.includes("callback=null"));

          const foundId = location.search
            .substring(1)
            .split("&")
            .filter((item) => !item.includes("oaid"))
            .find((item) => item.includes("id="));
          if (notCallbackFunc) {
            return;
          }
          const postMessageData = {
            cmd: "follow_success",
            id: foundId?.replace("id=", ""),
            uid: data.uid,
          };
          window.callbackFunc(postMessageData);
        })
        .catch((error: any) => {
          console.error(error);
          setIsLoading(false);
        });
    },
    [isLogged, isLoading]
  );

  const checkFollow = useCallback(
    (atk: string) => {
      const filterEntry = location.search
        .substring(1)
        .split("&")
        .map((item) => item.split("="))
        .filter((item) => FOLLOW_ENTRY.includes(item[0]));
      const convertToObject = Object.fromEntries(filterEntry);
      const entry = {
        t: atk,
        ...convertToObject,
        customize: false,
      };

      onRequestCheckFollow(entry)
        .then((rs: any) => {
          const data = rs as FollowI;
          if (data.error === CODE.SUCCESS) {
            if (data.followFlg === FOLLOW_FLG_ENUM.FOLLOWED) {
              setIsLogged(true);
              const foundCheckStatusFunc = location.search
                .substring(1)
                .split("&")
                .find((item) => item.includes("cbfollowed=null"));
              const foundId = location.search
                .substring(1)
                .split("&")
                .filter((item) => !item.includes("oaid"))
                .find((item) => item.includes("id="));

              if (!foundCheckStatusFunc) {
                const postMessageData = {
                  cmd: "cb_followed",
                  id: foundId?.replace("id=", ""),
                };
                window.checkStatusFunc(postMessageData);
              }
            }
          }
          setIsLoading(false);
        })
        .catch((error: any) => {
          console.error(error);
          setIsLoading(false);
        });
    },
    [isLogged, isLoading]
  );

  const openZLoginPopup = useCallback(() => {
    const continueUrl = encodeURIComponent(
      `${window.location.href}&auto_close=true`
    );
    console.log("window.location.href: ", window.location.href);

    const data = {
      url: `https://id.zalo.me/account?continue=${continueUrl}`,
      w: 500,
      h: 600,
    };

    var left = window.screen.width / 2 - data.w / 2;
    var top = window.screen.height / 2 - data.h / 2;
    let newWindow = window.open(
      data.url,
      "_blank",
      "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
      data.w +
      ", height=" +
      data.h +
      ", top=" +
      top +
      ", left=" +
      left
    );

    const zShareTimer = setInterval(() => {
      if (newWindow && newWindow.closed) {
        clearInterval(zShareTimer);
        checkHaveSession()
          .then((result: any) => {
            const data = result as SessionI;
            // have not logged in
            if (data.error === CODE.SUCCESS && data.atk) {
              handleFollow(data.atk);
            } else {
              setIsLoading(false);
            }
          })
          .catch((error: any) => {
            setIsLoading(false);
            console.error(error);
          });
      }
    }, 1000);
  }, [handleFollow]);

  const openZMobileLoginPopup = useCallback(() => {
    const codeVerifier = `${generateACharacter().toUpperCase()}${generateACharacter().toLowerCase()}${Math.floor(
      Math.random() * 10
    )}${generateString(40)}`;

    const sha256 = cryptoJS.SHA256(codeVerifier);
    const base64 = cryptoJS.enc.Base64.stringify(sha256).replace(/={1,2}$/, "");

    const parentPage = new URLSearchParams(window.location.search).get(
      "domain"
    );

    const foundOaId = location.search
      .substring(1)
      .split("&")
      .find((item) => item.includes("oaid="));

    let oaId = "";

    if (foundOaId) {
      oaId = foundOaId.replace("oaid=", "");
      oaId = `&oaid=${oaId.toString()}`;
    }

    const params = {
      app_id: "246740422184180283",
      redirect_uri: `https://button-follow.zalo.me/callback?redirectTo=${parentPage}${oaId}`,
      code_challenge: base64,
      state: +Date.now().toString(),
    };
    const qs = Object.entries(params)
      .map((param) => `${param[0]}=${encodeURIComponent(param[1])}`)
      .join("&");

    const continueUrl = encodeURIComponent(
      `https://oauth.zaloapp.com/v4/permission?${qs}`
    );
    const url = `https://id.zalo.me/account/login?continue=${continueUrl}`;

    window.open(url, "_parent");
  }, []);

  const openZNewTabLogin = useCallback(() => {
    const continueUrl = encodeURIComponent(
      `${window.location.href}&auto_close=true`
    );

    const href = `https://id.zalo.me/account?continue=${continueUrl}`;
    Object.assign(document.createElement("a"), {
      target: "_blank",
      href: href,
    }).click();
  }, []);

  useEffect(() => {
    const redirectTo =
      new URLSearchParams(window.location.search).get("redirectTo") || "";

    if (redirectTo) {
      setIsRedirecting(true);
      if (isValidURL(redirectTo)) {
        checkHaveSession()
          .then((result: any) => {
            const data = result as SessionI;
            // have not logged in
            if (data.error === CODE.SUCCESS && data.atk) {
              handleFollow(data.atk);
            } else {
              window.open(redirectTo, "_parent");
              setIsLoading(false);
            }
          })
          .catch((error: any) => {
            setIsLoading(false);
            window.open(redirectTo, "_parent");
            console.error(error);
          });
      }
    } else {
      // check user login ???
      setIsLoading(true);
      checkHaveSession()
        .then((result: any) => {
          const data = result as SessionI;
          // have not logged in
          if (data.error === CODE.SUCCESS && data.atk) {
            checkFollow(data.atk);
          } else {
            setIsLoading(false);
          }
        })
        .catch((error: any) => {
          console.error(error);
          setIsLoading(false);
        });
    }
  }, []);

  const onToggle = useCallback(() => {
    if (isZaloPay) {
      const query = new URLSearchParams(location.search);
      const oaId = query.get("oaid");
      if (oaId) {
        window.open(`https://zalo.me/${oaId.toString()}`, "_parent");
        return;
      }
    }

    if (isLoading || isLogged) {
      const notCallbackFunc = location.search
        .substring(1)
        .split("&")
        .find((item) => item.includes("callback=null"));

      if (notCallbackFunc || isLoading) {
        return;
      }
    }

    setIsLoading(true);
    if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
      checkHaveSession()
        .then((result: any) => {
          const data = result as SessionI;
          // have not logged in
          if (data.error === CODE.SUCCESS && data.atk) {
            handleFollow(data.atk);
          } else {
            setIsLoading(false);
            openZMobileLoginPopup();
          }
        })
        .catch((error: any) => {
          setIsLoading(false);
          openZMobileLoginPopup();
        });
    } else if (isMobile()) {
      hasStorageAccess(
        () => {
          checkHaveSession()
            .then((result: any) => {
              const data = result as SessionI;
              // have not logged in
              if (data.error === CODE.SUCCESS && data.atk) {
                handleFollow(data.atk);
              } else {
                // logged in
                openZMobileLoginPopup();
              }
            })
            .catch((error: any) => {
              openZMobileLoginPopup();
            });
        },
        () => {
          openZMobileLoginPopup();
        }
      );
    } else {
      const performLoginFlow = () => {
        checkHaveSession()
          .then((result: any) => {
            const data = result as SessionI;
            // have not logged in
            if (data.error === CODE.SUCCESS && data.atk) {
              handleFollow(data.atk);
            } else {
              if (usingBrowser() === "Apple Safari") {
                openZNewTabLogin();
                setIsLoading(false);
              } else {
                openZLoginPopup();
              }
            }
          })
          .catch((error: any) => {
            console.error(error);
            if (usingBrowser() === "Apple Safari") {
              openZNewTabLogin();
              setIsLoading(false);
            } else {
              openZLoginPopup();
            }
          });
      };

      if (usingBrowser() === "Apple Safari") {
        document.hasStorageAccess().then((hasAccess) => {
          if (hasAccess) {
            performLoginFlow();
          } else {
            document.requestStorageAccess().then(
              () => {
                // access granted
                performLoginFlow();
              },
              () => {
                // access denied, fallback to new tab
                openZNewTabLogin();
                setIsLoading(false);
              }
            );
          }
        });
      } else {
        performLoginFlow();
      }
    }
  }, [
    isLoading,
    isLogged,
    handleFollow,
    openZLoginPopup,
    openZMobileLoginPopup,
    openZNewTabLogin,
    isZaloPay,
  ]);

  const onStorageAccess = (action: () => void) => {
    document.hasStorageAccess().then((hasAccess) => {
      if (hasAccess) {
        console.log("hasAccess")
        action();
      } else {
        console.log("no hasAccess")
        document.requestStorageAccess().then(
          () => {
            console.log("accepted")
            action();
          },
          () => {
            console.log("rejected")
            action();
          },
        );
      }
    });
  }

  const hasStorageAccess = (success: () => void, fail: () => void) => {
    document.hasStorageAccess()
      .then(hasAccess => {
        if (hasAccess) {
          success();
        } else {
          fail()
        }
      })
  }

  if (isRedirecting === null && isLoading === null) {
    return null;
  }

  if (isAutoClose) {
    window.close();
  }

  return isRedirecting ? (
    <p
      style={{
        marginLeft: "4px",
      }}
    >
      Đang chuyển hướng trang, vui lòng đợi....
    </p>
  ) : (
    <div
      className={owlClass}
      style={
        isCustomize
          ? {
            width: "100%",
            height: "100vh",
            minWidth: "unset",
          }
          : {}
      }
      onClick={() => {
        onStorageAccess(onToggle)
      }}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <img
            className={`${owlClass}__icon`}
            src="https://sp.zalo.me/static/follow/images/logo_white_s_2x.png"
            alt=""
          />
          <span className={`${owlClass}__label`}>
            {isLogged ? "Đã quan tâm" : "Quan tâm"}
          </span>
        </>
      )}
    </div>
  );
}

export default App;
